import _ from 'lodash';

export default class ProductFL {
  constructor(data) {
    this.id = _.get(data, 'plu', '');
    this.codeSupplier = _.get(data, 'codeSupplier', '');
    this.name = _.get(data, 'name', '');
    this.packaging = _.get(data, 'purchaseUnit.name', '');
    this.unit = _.get(data, 'unit', '');
    this.supplier = _.get(data, 'mercurialName', '').toUpperCase();
    this.price = _.get(data, 'price', '');
    this.uc = _.get(data, 'purchaseUnit.name', '');
    this.conditionning = _.get(data, 'purchaseUnit.conditioning', 0);
    this.ean = _.get(data, 'ean', '');
    this.tag = _.get(data, 'categories', 'Pas de cat�gorie');
    this.pic = _.get(data, 'image', '');
  }
}
